import {
    SHOW_POPUP,
    SHOW_SAVE_GRID_VIEW,
    HIDE_SAVE_GRID_VIEW,
    GET_CUSTOM_VIEW_REQUEST,
    GET_CUSTOM_VIEW_SUCCESS,
    GET_CUSTOM_VIEW_FAIL,
    SAVE_GRID_VIEW_REQUEST,
    SAVE_GRID_VIEW_FAIL,
    SAVE_GRID_VIEW_SUCCESS,
} from '../constants/action-types';

import { getCustomViewsRequest, saveCustomViewRequest } from '../services/api';

import { autoLogin } from './userActions';

const hideGridViewPopup = () => ({
    type: HIDE_SAVE_GRID_VIEW,
});

const showGridViewPopup = (mode, data) => ({
    type: SHOW_SAVE_GRID_VIEW,
    payload: {
        mode,
        data: mode === 'update' ? data : {},
    },
});

const showUpdateGridViewPopup = viewId => (dispatch, getState) => {
    const view = getState().markets.customViews.find(v => v.id === viewId);

    dispatch(showGridViewPopup('update', view));
};

const getCustomViews = () => async dispatch => {
    dispatch({
        type: GET_CUSTOM_VIEW_REQUEST,
    });
    try {
        const result = await getCustomViewsRequest();

        dispatch({
            type: GET_CUSTOM_VIEW_SUCCESS,
            payload: result.data,
        });
    } catch (error) {
        dispatch({
            type: GET_CUSTOM_VIEW_FAIL,
            error,
        });
    }
};

const saveGridView = (mode, params) => async dispatch => {
    dispatch({
        type: SAVE_GRID_VIEW_REQUEST,
    });
    try {
        await saveCustomViewRequest(mode, params);

        dispatch({
            type: SAVE_GRID_VIEW_SUCCESS,
        });
        dispatch(autoLogin());
        dispatch(getCustomViews());
        dispatch(hideGridViewPopup());
        dispatch({
            type: SHOW_POPUP,
            popupProps: {
                title: 'Success',
                content: `Tab view was saved`,
            },
        });
    } catch (error) {
        dispatch({
            type: SAVE_GRID_VIEW_FAIL,
            error,
        });

        const { data, status } = error.response;
        // TODO add to ajaxErrorsInterceptor
        if (status === 400) {
            dispatch({
                type: SHOW_POPUP,
                popupProps: {
                    title: 'Error',
                    content: JSON.stringify(data),
                },
            });
        }
    }
};

export { saveGridView, hideGridViewPopup, showGridViewPopup, showUpdateGridViewPopup };



// WEBPACK FOOTER //
// ./source/actions/customViewsActions.js